<template>
  <div>
    <div class="row">
      <label class="col-lg-2 col-form-label" for="ddlIntercomNavigation">Intercom Navigation</label>
      <div class="col-md-12 col-lg-5">
        <select class="form-control" id="ddlIntercomNavigation" v-model="selected"
                @change="routerPush">
          <option value="AdminIntercomCommands">Commands</option>
          <option value="AdminExternalSipIndex">External SIP</option>
          <option value="AdminIntercomVars" v-if="scoped_site_id === 1">vars.xml</option>
          <option value="AdminDialplanPublic">dialplan/public.xml</option>
          <option value="AdminDialplanDefault">dialplan/default.xml</option>
          <option value="AdminSIPProfileInternal">sip_profiles/internal.xml</option>
          <option value="AdminSIPProfileExternal" v-if="scoped_site_id === 1">sip_profiles/external.xml</option>
        </select>
      </div>
    </div>
    <br>
    <div class="row">
      <div class="col-12">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import router from '../../../router'

export default {
  data: function () {
    return {
      selected: 'AdminIntercomCommands'
    }
  },
  computed: {
    ...mapGetters({
      scoped_site_id: 'scopedSiteId'
    })
  },
  methods: {
    routerPush () {
      router.push({ name: this.selected })
    }
  }
}
</script>

<style scoped>

</style>
